module.exports = __webpack_public_path__ + "e0507d475afde72e7f548e63f4c891a0.png";